import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getCrews,
  planningTime,
} from "../../../../services/RHService/CrewService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { TextField } from "@material-ui/core";

const TimePlanning = () => {
  const navigate = useNavigate();
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  const animatedComponents = makeAnimated();
  const [crewNames, setCrewNames] = useState([]);
  const [crewId, setCrewId] = useState([]);
  const [allCrew, setAllCrew] = useState([]);
  const [dateDeb, setDateDeb] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [heureDeb, setHeureDeb] = useState("");
  const [heureFin, setHeureFin] = useState("");

  const [crewSelectPlaceHolder, setCrewSelectPlaceHolder] =
    useState("Choisir une équipe");
  const [selectedOptionCrew, setSelectedOptionCrew] = useState(null);

  useEffect(() => {
    getCrews(getCurrentUserId())
      .then((names) => {
        setCrewNames(names.data.success);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  useEffect(() => {
    console.log(crewNames);
    crewNames &&
      crewNames.map((element, i) => {
        setAllCrew((oldArray) => [
          ...oldArray,
          { value: element.idEquipe, label: element.nomEquipe },
        ]);
      });
  }, [crewNames]);
  // const [formData, setFormData] = useState({});
  // const handleInputChange = async (event) => {
  //     try {
  //         const target = event.target;
  //         const name = target.name;
  //         const value = target.type === 'checkbox' ? target.checked : target.value;
  //         setFormData({ ...formData, [name]: value });
  //     } catch (error) {
  //         console.error(error);
  //     }
  // };
  const handlePlanningTime = async (event) => {
    event.preventDefault();

    if (!dateDeb || !dateFin || !heureDeb || !heureFin) {
      toastr.error("Veuillez renseigner tous les champs.");
    } else if (crewId === "equipe" || !crewId) {
      toastr.error("Veuillez renseigner tous les champs.");
    } else {
      let formData = {
        idEquipe: crewId,
        dateDeb: dateDeb,
        dateFin: dateFin,
        heureDeb: heureDeb,
        heureFin: heureFin,
      };

      planningTime(getCurrentUserId(), formData)
        .then((response) => {
          toastr.success("Planning fait avec succée.");
          setTimeout(() => {
            navigate(`/crewList`);
          }, 2000);
        })
        .catch((error) => {
          toastr.error("Erreur lors de Plannification.");
        });
    }
  };
  const onChangeSelectedCrew = (selectedOptionn) => {
    setSelectedOptionCrew();
    setCrewId(selectedOptionn.value);
    setCrewSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeDateDeb = (event) => {
    setDateDeb(event.target.value);
  };

  const onChangeDateFin = (event) => {
    setDateFin(event.target.value);
  };

  const onChangeHeureDeb = (event) => {
    setHeureDeb(event.target.value);
  };
  const onChangeHeureFin = (event) => {
    setHeureFin(event.target.value);
  };
  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Plannification de temps</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/crewList" style={{ color: "black" }}>
                    Liste des équipes
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Plannification de temps
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Plannification de temps</h4>
                </div>
                <form onSubmit={handlePlanningTime}>
                  <div className="row">
                    <div className="card-body">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="exampleSelectBorder">Nom d'equipe </label>
                          <Select
                            styles={styles}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOptionCrew}
                            onChange={onChangeSelectedCrew}
                            autosize={false}
                            options={allCrew}
                            placeholder={crewSelectPlaceHolder}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Date début</label>
                            <div className="input-group date">
                              {/* <input type="date" onChange={handleInputChange} value={formData.dateDeb}
                                                                name="dateDeb" min="1900-01-01" max="2100-12-31" className="form-control form-control-border" /> */}

                              <TextField
                                style={{ width: "100%" }}
                                className="col-sm-12"
                                variant="outlined"
                                value={dateDeb}
                                onChange={onChangeDateDeb}
                                id="datetime-local"
                                // label="Date Début"
                                type="date"
                                defaultValue="date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Date fin</label>
                            <div className="input-group date">
                              {/* <input type="date" onChange={handleInputChange} value={formData.dateFin}
                                                                name="dateFin" max="2100-12-31" className="form-control form-control-border" /> */}

                              <TextField
                                style={{ width: "100%" }}
                                className="col-sm-12"
                                variant="outlined"
                                value={dateFin}
                                onChange={onChangeDateFin}
                                id="datetime-local"
                                // label="Date Début"
                                type="date"
                                defaultValue="date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="form-group">
                            <label>Heure début</label>
                            <div class="input-group date">
                              {/* <input className="form-control form-control-border" onChange={handleInputChange} value={formData.heureDeb}
                                                                name="heureDeb" type="time" /> */}

                              <TextField
                                style={{ width: "100%" }}
                                className="col-sm-12"
                                variant="outlined"
                                value={heureDeb}
                                onChange={onChangeHeureDeb}
                                id="datetime-local"
                                // label="Date Début"
                                type="time"
                                defaultValue="time"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="form-group">
                            <label>Heure fin</label>
                            <div class="input-group date">
                              {/* <input className="form-control form-control-border" type="time" onChange={handleInputChange} value={formData.heureFin}
                                                                name="heureFin" /> */}

                              <TextField
                                style={{ width: "100%" }}
                                className="col-sm-12"
                                variant="outlined"
                                value={heureFin}
                                onChange={onChangeHeureFin}
                                id="datetime-local"
                                // label="Date Début"
                                type="time"
                                defaultValue="time"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-dark col-md-3 float-right"
                      style={{ width: "auto" }}
                    >
                      Appliquer
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TimePlanning;
